// extracted by mini-css-extract-plugin
export default {"clientes":"Clientes_clientes__BjpjY","titulo":"Clientes_titulo__5JIGo","link":"Clientes_link__h-Dtx"};